import axios from 'axios';
import { toast } from 'react-toastify';

interface IFormSignUp {
  registration: string;
}

interface IForgotPasswordConfirm {
  code: string;
  registration: string;
  new_password: string;
}

const forgotPassword = async ({ registration }: IFormSignUp): Promise<void> => {
  try {
    await axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/cognito/forgot-password`, {
        registration,
      })
      .then(response => {});

    return Promise.resolve();
  } catch (err) {
    toast.error(
      'Algo deu errado ao solicitar a recuperação de senha. Tente novamente.',
    );

    return Promise.reject();
  }
};

const forgotPasswordConfirm = async ({
  registration,
  code,
  new_password,
}: IForgotPasswordConfirm) => {
  try {
    await axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/cognito/forgot-password-confirm`,
        {
          registration,
          code,
          new_password,
        },
      )
      .then(response => {
        toast.success('Senha redefinida com sucesso!');
      });

    return Promise.resolve();
  } catch (err) {
    toast.error('Algo deu errado ao redefinir a senha. Tente novamente.');

    return Promise.reject();
  }
};

export { forgotPassword, forgotPasswordConfirm };
